import { getLocaleString } from "lib/localization/vendor";

interface FeatureVariationProps {
	id:string,
	name?:string,
	localeName?:string,
	colorHex:string,
	isDefault:boolean,
	description?:string,
	localeDescription?:string,
	image?:string,
	hideLabel?:boolean
}

/**
	* Feature variation class for different feature variations
	* 
	* @remarks
	* Used mainly in /views/DrawTool
	* 
	* @param {string} id - id of variation
	* @param {string} name - name of variation
	* @param {boolean} isDefault - Is this variation the default selected one?
	* @param {string} description - Description of the variation shown in the selection UI
	* @param {string} image - Icon url for the variation shown in the selection UI (not required)
	* @param {string} colorHex - Color hex code
*/
export default class FeatureVariation implements FeatureVariationProps {
	public id:string;
	public name:string;
	public localeName:string;
	public isDefault:boolean;
	public hideLabel:boolean;
	public description:string;
	public localeDescription:string;
	public image:string;
	public colorHex:string;
	
	constructor({id, name, localeName, isDefault, hideLabel, description, localeDescription, image, colorHex}:FeatureVariationProps) {
		this.id = id;
		this.name = name;
		this.localeName = localeName;
		this.isDefault = isDefault;
		this.hideLabel = hideLabel;
		this.colorHex = colorHex;
		this.description = description;
		this.localeDescription = localeDescription;
		this.image = image;
	}
	
	public getName():string {
		return this.localeName ? getLocaleString(this.localeName) : this.name;
	}
	public getDescription():string {
		return this.localeDescription ? getLocaleString(this.localeDescription) : this.description;
	}
}

/**
	* Find the index of the default variation
	* 
	* @param {FeatureVariation[]} variations - Variations array
	* 
	* @returns {number} Index of default variation
*/
export function findDefaultIndex(variations:FeatureVariation[]):number {
	for(let i = 0; i < variations.length; i++) {
		if(variations[i].isDefault)
			return i;
	}
	
	return 0;
}